import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  FaUserMd,
  FaBriefcaseMedical,
  FaClock,
  FaMoneyBillWave,
  FaBrain,
  FaMicroscope,
  FaAmbulance,
  FaHospitalSymbol,
} from "react-icons/fa";


import ROOT_URL from "../../Utilities/apiconfig";
import ContactMarquee from "../Pages/ContactMarquee";

const Doctors = () => {
  const [doctors, setDoctors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDoctors = async () => {
      try {
        const response = await axios.get(`${ROOT_URL}/api/medicos`);
        setDoctors(response.data);
        setLoading(false);
      } catch (err) {
        setError("Failed to fetch doctors data");
        setLoading(false);
      }
    };
    fetchDoctors();
  }, []);

  if (loading) return <p>Loading doctors...</p>;
  if (error) return <p>{error}</p>;

  const featuredDoctor = doctors.length > 0 ? doctors[0] : null;
  const displayedDoctors = doctors.slice(1);

  return (
    <>
      <Helmet>
        <title>Columbiaa Hospital | Best Multi-Speciality Hospital in Kasturi Nagar Bangalore - Expert Doctors</title>
        <meta name="description" content="Columbiaa Hospital is the best multi-speciality hospital in Kasturi Nagar, Bangalore. Meet our expert doctors including top neurosurgeons, experienced physicians, and skilled surgeons. Book appointments online for world-class healthcare." />
        <meta name="keywords" content="hospital, best hospital, multi-speciality hospital, doctors, neurosurgeon, top doctor, brain surgeon, spine surgeon, neurosurgeon in Bangalore, hospital in Kasturi Nagar, Columbiaa Hospital, expert doctors, medical treatment, healthcare, Bangalore hospital, specialist doctor, book appointment, neurosurgeon Bangalore, top neurosurgeon India, brain surgery Bangalore, spine surgery Bangalore" />
        <meta name="author" content="Columbiaa Hospital" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Columbiaa Hospital | Best Multi-Speciality Hospital in Kasturi Nagar Bangalore - Expert Doctors" />
        <meta property="og:description" content="Meet expert doctors at Columbiaa Hospital, the top multi-speciality hospital in Kasturi Nagar, Bangalore. Best neurosurgeons and medical specialists available for appointments." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://columbiaahospital.com/doctors" />
        <meta property="og:site_name" content="Columbiaa Hospital" />
        <meta property="og:locale" content="en_IN" />
        <link rel="canonical" href="https://columbiaahospital.com/doctors" />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "MedicalOrganization",
              "name": "Columbiaa Hospital",
              "url": "https://columbiaahospital.com",
              "logo": "https://columbiaahospital.com/assets/images/zclogo.png",
              "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+91-8548979899",
                "contactType": "appointments",
                "areaServed": "IN",
                "availableLanguage": ["English", "Hindi", "Kannada"]
              },
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "Building No 06, 5th Main Rd, B Channasandra, OMBR Layout",
                "addressLocality": "Bengaluru",
                "addressRegion": "Karnataka",
                "postalCode": "560043",
                "addressCountry": "IN"
              },
              "sameAs": [
                "https://www.facebook.com/share/1BFLVsneD2/",
                "https://x.com/columbiaahosp",
                "https://www.linkedin.com/in/columbiaa-hospital-kasturi-nagar-bengaluru-98aa37323/",
                "https://www.instagram.com/columbiaahospital/",
                "https://www.youtube.com/@columbiaahospital"
              ]
            }
          `}
        </script>
      </Helmet>

      {/* Header Section */}
      <section
        className="doctor-header text-center py-5" data-aos="fade-down"
        style={{ backgroundColor: "#1e1c42", color: "#fff", overflowX: 'hidden' }}
      >
        <h1 style={{ fontSize: "36px", fontWeight: "bold", color: "#fff" }}>
          Meet Our Expert Doctors
        </h1>
        <p style={{ fontSize: "18px", marginTop: "10px", color: "#fff" }}>
          Experienced & Skilled Medical Professionals Dedicated to Your Health
        </p>
      </section>

      {featuredDoctor && (
        <div
          className="container my-5 p-4 rounded shadow-lg text-white"
          style={{ backgroundColor: "#1e1c42", overflowX: 'hidden' }}
        >
          <div className="row align-items-center">
            {/* Left Side - Doctor Info */}
            <div className="col-md-7" data-aos="fade-right">
              <h2
                style={{ fontWeight: "bold", fontSize: "32px", color: "#fff" }}
              >
                {featuredDoctor.name}
              </h2>
              <h6 className="my-2" style={{ color: "#fff", fontWeight: "normal" }} title={`Qualification: ${featuredDoctor.qualification}`}>
                {featuredDoctor.qualification}
              </h6>
              <h4 style={{ fontWeight: "bold", color: "#fff" }}>
                {featuredDoctor.designation}
              </h4>
             
              <h6 className="py-2" style={{ color: "#fff", fontWeight: "normal" }} title={`Experience: ${featuredDoctor.experience}`}>
              Experience :  {featuredDoctor.experience} years
              </h6>
              <p style={{ fontSize: "16px", marginTop: "10px", color: "#ddd" }}>
                {featuredDoctor.bio}
              </p>

              <button
                className="btn my-5"
                style={{
                  backgroundColor: "#64F8E0",
                  color: "#1e1c42",
                  borderRadius: "8px",
                  padding: "10px 20px",
                  fontWeight: "bold",
                }}
                onClick={() =>
                  navigate(`/bookappointments/${featuredDoctor._id}`)
                }
              >
                Book Appointment
              </button>
            </div>

            {/* Right Side - Doctor Image */}
            <div className="col-md-5 text-center" data-aos="fade-down-left">
              <img
                src={`${ROOT_URL}/uploads/medicos/${featuredDoctor.image}`}
                alt={featuredDoctor.name}
                style={{
                  width: "100%",
                  borderRadius: "20px",
                  border: "5px solid #64F8E0",
                  objectFit: "cover",
                  overflowX: 'hidden',
                }}
              />
            </div>
          </div>

          {/* Why Choose Our Doctors? - Integrated Section */}
          <div
            className="container text-center mt-5 p-4 rounded shadow-lg" 
            style={{ backgroundColor: "#f5f5f5", border: "2px solid #1e1c42", overflowX: 'hidden' }} data-aos="zoom-in"
          >
            <h2
              style={{ fontWeight: "bold", fontSize: "28px", color: "#1e1c42" }}
            >
              Consultant in Brain & Spine Disorders
            </h2>
            <p
              style={{ fontSize: "16px", color: "#555", marginBottom: "20px" }}
            >
              Experienced Professional | Personalized Care | Advanced
              Treatments
            </p>

            <div className="row justify-content-center border" style={{ overflowX: 'hidden' }}>
              {/* Left Column */}
              <div className="col-md-4">
                <div
                  className="info-box d-flex align-items-center p-3 mb-3 rounded shadow-sm"
                  style={{
                    backgroundColor: "#fff",
                    border: "1px solid #1e1c42",
                    overflowX: 'hidden',
                  }}
                >
                  <FaUserMd color="#1e1c42" size={20} className="me-2" />
                  <p className="mb-0" style={{ color: "#1e1c42" }}>
                    <b>Highly Qualified Doctor</b>
                  </p>
                </div>

                <div
                  className="info-box d-flex align-items-center p-3 mb-3 rounded shadow-sm"
                  style={{
                    backgroundColor: "#fff",
                    border: "1px solid #1e1c42",
                    overflowX: 'hidden',
                  }}
                >
                  <FaBrain color="#1e1c42" size={20} className="me-2" />
                  <p className="mb-0" style={{ color: "#1e1c42" }}>
                    <b>Expert Neurosurgeon</b>
                  </p>
                </div>

                <div
                  className="info-box d-flex align-items-center p-3 mb-3 rounded shadow-sm"
                  style={{
                    backgroundColor: "#fff",
                    border: "1px solid #1e1c42",
                    overflowX: 'hidden',
                  }}
                >
                  <FaMicroscope color="#1e1c42" size={20} className="me-2" />
                  <p className="mb-0" style={{ color: "#1e1c42" }}>
                    <b>Minimally Invasive Procedures</b>
                  </p>
                </div>
              </div>

              {/* Middle Column */}
              <div className="col-md-4">
                <div
                  className="info-box d-flex align-items-center p-3 mb-3 rounded shadow-sm"
                  style={{
                    backgroundColor: "#fff",
                    border: "1px solid #1e1c42",
                    overflowX: 'hidden',
                  }}
                >
                  <FaBriefcaseMedical
                    color="#1e1c42"
                    size={20}
                    className="me-2"
                  />
                  <p className="mb-0" style={{ color: "#1e1c42" }}>
                    <b>36 + Years of Expertise</b>
                  </p>
                </div>

                <div
                  className="info-box d-flex align-items-center p-3 mb-3 rounded shadow-sm"
                  style={{
                    backgroundColor: "#fff",
                    border: "1px solid #1e1c42",
                    overflowX: 'hidden',
                  }}
                >
                  <FaBrain color="#1e1c42" size={20} className="me-2" />
                  <p className="mb-0" style={{ color: "#1e1c42" }}>
                    <b>Brain & Spine Disorders Specialists</b>
                  </p>
                </div>

                <div
                  className="info-box d-flex align-items-center p-3 mb-3 rounded shadow-sm"
                  style={{
                    backgroundColor: "#fff",
                    border: "1px solid #1e1c42",
                    overflowX: 'hidden',
                  }}
                >
                  <FaClock color="#1e1c42" size={20} className="me-2" />
                  <p className="mb-0" style={{ color: "#1e1c42" }}>
                    <b>Daily Outpatient Consultation</b>
                  </p>
                </div>
              </div>

              {/* Right Column */}
              <div className="col-md-4">
                <div
                  className="info-box d-flex align-items-center p-3 mb-3 rounded shadow-sm"
                  style={{
                    backgroundColor: "#fff",
                    border: "1px solid #1e1c42",
                    overflowX: 'hidden',
                  }}
                >
                  <FaClock color="#1e1c42" size={20} className="me-2" />
                  <p className="mb-0" style={{ color: "#1e1c42" }}>
                    <b>Flexible Appointment Scheduling</b>
                  </p>
                </div>

                <div
                  className="info-box d-flex align-items-center p-3 mb-3 rounded shadow-sm"
                  style={{
                    backgroundColor: "#fff",
                    border: "1px solid #1e1c42",
                    overflowX: 'hidden',
                  }}
                >
                  <FaHospitalSymbol
                    color="#1e1c42"
                    size={20}
                    className="me-2"
                  />
                  <p className="mb-0" style={{ color: "#1e1c42" }}>
                    <b>Micro Neurosurgery</b>
                  </p>
                </div>

                <div
                  className="info-box d-flex align-items-center p-3 mb-3 rounded shadow-sm"
                  style={{
                    backgroundColor: "#fff",
                    border: "1px solid #1e1c42",
                    overflowX: 'hidden',
                  }}
                >
                  <FaAmbulance color="#1e1c42" size={20} className="me-2" />
                  <p className="mb-0" style={{ color: "#1e1c42" }}>
                    <b>Emergency Neurosurgical Care</b>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Doctors Grid Section */}
      <div className="container py-5" style={{ overflowX: 'hidden' }}>
        <div className="row" style={{ overflowX: 'hidden' }}>
          {displayedDoctors.map((doctor) => (
            <div key={doctor._id} className="col-lg-3 col-md-4 col-sm-6 mb-4">
              <div className="class_box shadow bg-white rounded p-3" style={{border:'1px solid teal'}}>
                {/* Top Section: Image + Name + Designation */}
                <div className="d-flex align-items-center">
                  {/* Left: Doctor Image */}
                  <div className="class_Img" data-aos="fade-down-right" style={{ width: "35%", display: "flex", justifyContent: "center", alignItems: "center", border:'3px solid teal', borderRadius:'50%' }} aria-label={`Profile picture of Dr. ${doctor.name}`}>
                    <img 
                      src={`${ROOT_URL}/uploads/medicos/${doctor.image}`} 
                      alt={doctor.name} 
                      style={{ 
                        width: "100%", 
                        height: "10vh", 
                        borderRadius: "50%", 
                        objectFit: "cover" 
                      }} 
                    />
                  </div>

                  {/* Right: Doctor Name & Designation */}
                  <div className="ps-3" data-aos="fade-left" style={{ width: "70%" }} aria-label={`Doctor's Name and Designation`}>
                    <h6 style={{ fontSize: "16px", fontWeight: "bold", marginBottom: "4px", color: "#1e1c42" }}  title={`Dr. ${doctor.name}`}>{doctor.name}</h6>
                    <h6 className="mb-2" style={{fontSize: "12px", color: "#000", fontWeight: "normal" }} title={`Qualification: ${doctor.qualification}`}> 
                {doctor.qualification}
              </h6>
                    <h6 style={{ fontSize: "14px", fontWeight: "bold", color: "#555", marginBottom: "0" }}>{doctor.designation}</h6>
                  </div>
                </div>

                {/* Bottom Section: Details & Button */}
                <div className="mt-3 text-center">
               
              <h6 className="pb-3" style={{ color: "#000", fontWeight: "normal" }} title={`Experience: ${doctor.experience}`}>
              Experience :  {doctor.experience} years
              </h6>
                  <p style={{ fontSize: "14px", color: "#777", marginBottom: "8px" }} aria-label={`Doctor Bio: ${doctor.bio}`}>{doctor.bio}</p>
                  <p><FaClock color="#1e1c42" /> <b>Availability:</b> {doctor.availability || "Flexible"}</p>
                  <button 
                    className="btn mt-2" 
                    style={{ backgroundColor: "#1e1c42", color: "#fff", borderRadius: "8px", padding: "8px 12px", width: "100%" }}
                    onClick={() => navigate(`/bookappointments/${doctor._id}`)}  aria-label={`Book appointment with doctor ${doctor.name}`}
                    title="Book Appointment"
     disabled={
  doctor.name === "Dr S Arivazhagan" ||
  doctor.name === "Dr. Munireddy M V" ||
  doctor.name === "Dr Ramanjanayalu" ||
  doctor.name === "Dr Anagha Auradkar" ||
  doctor.name === "Dr. Chandra Shekar M" ||
  doctor.name === "Dr Volga Joshy (PT)" ||
  doctor.name === "Dr Swetha" ||
  doctor.name === "Dr Mahesh"
}


                  >
                    Book Appointment
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

     <ContactMarquee/>
    </>
  );
};

export default Doctors;
